import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";
import styled from "styled-components";
import Errors from "components/errors";

const InputForm = styled.div`
  ${tw`flex flex-col mb-[18px]`}

  label {
    ${tw`text-[14.4px] mb-2`}
    font-family: "circular-std", sans-serif;
    font-weight: 500;
  }
`;

const InputGroupAttached = styled.div`
  ${tw`flex`}

  input {
    flex: auto;
    padding: 15px 16px;
    border: 1px solid #a0a1a6;
    border-right: none;
    border-radius: 4px 0 0 4px;
    font-size: 16px;
    outline: none;

    &:focus,
    &:active {
      border-color: #2d983d;
    }

    &::placeholder {
      color: #a0a1a6;
    }
  }

  button {
    background: none;
    border: 1px solid #a0a1a6;
    border-left: none;
    border-radius: 0 4px 4px 0;
    padding: 0 1.25rem 0 1rem;
    color: #9ea0a5;
    outline: none;
    cursor: pointer;
  }
`;

class PasswordField extends PureComponent {
  static propTypes = {
    inputRef: PropTypes.any,
    inputProps: PropTypes.object,
    errors: PropTypes.array,
    label: PropTypes.string
  };

  state = {
    plainText: false
  };

  togglePassword = (event) => {
    event.preventDefault();
    this.setState({ plainText: !this.state.plainText });
  };

  render() {
    return (
      <InputForm>
        <label htmlFor="password">{this.props.label || "Password"}</label>
        <InputGroupAttached>
          <input
            type={this.state.plainText ? "text" : "password"}
            name="Password"
            required="required"
            id="password"
            pattern=".{6,}"
            title="Minimum of 6 characters"
            ref={this.props.inputRef}
            {...(this.props.inputProps || {})}
          />

          <button
            type="button"
            className="password-toggler"
            onClick={this.togglePassword}
          >
            <i
              className={
                this.state.plainText ? "fas fa-eye-slash" : "far fa-eye"
              }
            ></i>
          </button>
        </InputGroupAttached>
        <Errors errors={this.props.errors} />
      </InputForm>
    );
  }
}
export default PasswordField;
